import { render } from "./dropdownList.vue?vue&type=template&id=362c81f2&scoped=true"
import script from "./dropdownList.vue?vue&type=script&lang=js"
export * from "./dropdownList.vue?vue&type=script&lang=js"

import "./dropdownList.vue?vue&type=style&index=0&id=362c81f2&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362c81f2"]])

export default __exports__